<template>
<v-app>
<v-container fluid class="ma-0 pa-0" width="100%">
<v-card style="margin:10px">
<v-data-table
    :headers="headers1"
    :items="dnplan"
    light
    hide-actions
  >
  <template slot="items" slot-scope="props">
    <tr v-if="props.item.selected">
      <td>{{ props.item.subject }}</td>
      <td>{{ props.item.forestry }}</td>
      <td>{{ props.item.total_forest_area != null ? props.item.total_forest_area.toLocaleString(): 'н/д' }}</td>
      <td class='text-xss-left' v-for='month in months'>
        <v-checkbox :input-value="props.item[month]!=null" hide-details :disabled="getSumm(props.item, month).status && props.item[month] == null" @change="onMonthChange($event, props.item, month)"/>
        <input v-if='props.item[month]!=null' v-model="props.item[month]" type="number" :min="1" :max="props.item.total_forest_area" @input="onInput($event, props.item, month)"></input>
      </td>
      <td>
        {{getSumm(props.item, 'month1').sum.toLocaleString()}}
      </td>
    </tr>
  </template>
  <template slot="footer" v-if='selectedPlanItems.length > 0'>
    <tr v-for='item in getUniqueSubjects()'>
      <th>{{item}}</th>
      <th>{{sumFieldBySubject(item).toLocaleString() + ' Га'}}</th>
    </tr>
    <tr>
      <th>Итого:</th>
      <th>{{sumField().toLocaleString() + ' Га'}}</th>
    </tr>
    <tr>
      <td>
        
      </td>
    </tr>
  </template>
</v-data-table>
<v-btn @click='loadPlan'>Обновить</v-btn>
</v-card>
<v-card style="margin:20px">
 <v-data-table
    dense
    :headers="headers2"
    :items="dnplan"
    hide-actions
  >
  <template slot="items" slot-scope="props">
    <tr>
      <td>{{ props.item.subject }}</td>
      <td>{{ props.item.forestry }}</td>
      <td>{{ props.item.total_forest_area != null ? props.item.total_forest_area.toLocaleString(): 'н/д' }}</td>
      <td>{{ props.item.oldplan }}</td>
      <td><v-checkbox v-model="props.item.selected" primary hide-details></v-checkbox></td>
    </tr>
  </template>
  </v-data-table>
</v-card>
</v-container>
</v-app>
</template>
<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
export default {
  name: 'plan',
  components: {
  },
  data () {
    return {
        planYear: new Date().getFullYear(),
        title: "ФБУ Рослесозащита. Планирование работ по ДН",
        apiPath: '/api',
        months: ['month1', 'month2', 'month3', 'month4', 'month5', 'month6', 'month7', 'month8', 'month9', 'month10', 'month11', 'month12'],
        headers1: [
          { text: 'Субъект', value: 'subject'},
          { text: 'Лесничество', value: 'forestry'},
          { text: 'Лесов по ГЛР, га', value: 'total_forest_area'},
          { text: 'Январь', value: 'month1'},
          { text: 'Февраль', value: 'month2'},
          { text: 'Март', value: 'month3'},
          { text: 'Апрель', value: 'month4'},
          { text: 'Май', value: 'month5'},
          { text: 'Июнь', value: 'month6'},
          { text: 'Июль', value: 'month7'},
          { text: 'Август', value: 'month8'},
          { text: 'Сентябрь', value: 'month9'},
          { text: 'Октябрь', value: 'month10'},
          { text: 'Ноябрь', value: 'month11'},
          { text: 'Декабрь', value: 'month12'},
          { text: 'Итого, га', value: 'itogo'}
        ],
        headers2: [
          { text: 'Субъект', value: 'subject'},
          { text: 'Лесничество', value: 'forestry'},
          { text: 'Лесов по ГЛР, га', value: 'total_forest_area'},
          { text: 'Прошлые ДН', value: 'oldplan'},
          { text: 'Добавить в план', value: 'selected'}
        ],
        dnplan: [
        ]
    }
  },
  mounted: function() {
    this.getPlan(this.$route.query.filialid, this.planYear)
  },
  computed: {
    selectedPlanItems() {
      return this.dnplan.filter((item) => {return item.selected == true && this.getSumm(item, 'month1').sum > 0})
    },
    selectedPlanItems1() {
      return this.dnplan.filter((item) => {return item.selected == true})
    }
  },
  methods: {
    loadPlan() {
      var forestriesDel = this.dnplan.map((item) => {return item.forestry_id}).join(',')
      var ins = this.selectedPlanItems.map((item) => {
        return {subject: item.subject, les_vo: item.forestry, month1: item.month1, month2: item.month2, 
        month3: item.month3, month4: item.month4, month5: item.month5, month6: item.month6, month7: item.month7, 
        month8: item.month8, month9: item.month9, month10: item.month10, month11: item.month11, month12: item.month12,
        year: this.planYear, n_subject: item.n_subject, forestry_id: item.forestry_id}
      })
      this.$http.post('api/updateplan', {filialid: this.$route.query.filialid, ins: ins, del: {year: this.planYear, forestries: forestriesDel}}, {}).then(res => {
        alert('ок')
        //this.$router.push('/planedit')
      }, error => {
                
      })
    },
    getUniqueSubjects() {
      var lookup = {}
      var result = []
      for (var item, i = 0; item = this.dnplan[i]; i++) {
        var name = item.subject
        if (!(name in lookup) && item.selected == true) {
          lookup[name] = 1
          result.push(name)
        }
      }
      return result
    },
    sumField() {
      // sum data in given key (property)
      let total = 0
      const sum = this.dnplan.reduce((accumulator, currentValue) => {
          return (total += parseFloat(currentValue.month1||0)+parseFloat(currentValue.month2||0)+parseFloat(currentValue.month3||0)+parseFloat(currentValue.month4||0)+parseFloat(currentValue.month5||0)+
            parseFloat(currentValue.month6||0)+parseFloat(currentValue.month7||0)+parseFloat(currentValue.month8||0)+parseFloat(currentValue.month9||0)+
            parseFloat(currentValue.month10||0)+parseFloat(currentValue.month11||0)+parseFloat(currentValue.month12||0))
      }, 0)
      return sum
    },
    sumFieldBySubject(subject) {
      // sum data in given key (property)
      let total = 0
      if (this.dnplan.length < 1) {
        return 0
      }
      let filter = this.dnplan.filter(item => {return item.subject == subject})
      if (filter.length > 0) {
        const sum = filter.reduce((accumulator, currentValue) => {
          return (total += parseFloat(currentValue.month1||0)+parseFloat(currentValue.month2||0)+parseFloat(currentValue.month3||0)+parseFloat(currentValue.month4||0)+parseFloat(currentValue.month5||0)+
          parseFloat(currentValue.month6||0)+parseFloat(currentValue.month7||0)+parseFloat(currentValue.month8||0)+parseFloat(currentValue.month9||0)+parseFloat(currentValue.month10||0)+
          parseFloat(currentValue.month11||0)+parseFloat(currentValue.month12||0))
        }, 0)
        return sum
      } else {
        return 0
      }
    },
    onInput(e, item, month) {
      if(parseFloat(e.target.value) > parseFloat(item.total_forest_area) - this.getSumm(item, month).sum1) {
        item[month] = parseFloat(item.total_forest_area) - this.getSumm(item, month).sum1
      }
    },
    getSumm(item, m) {
      var sum = 0
      var sum1 = 0
      this.months.forEach((month) => {
        sum += parseFloat(item[month]||"0")
        if(month != m) {
          sum1 += parseFloat(item[month]||"0")
        }
      })
      return {status: sum >= item.total_forest_area, sum: sum, sum1: sum1}
    },
    onMonthChange(e, item, month) {
      if(e) {
        item[month] = item.total_forest_area - this.getSumm(item, month).sum
      }
      else {
        item[month] = null
      }
    },
    getPlan(filialid, year) {
      this.$http.get('api/dnplan', { params:{year: year, filialid: filialid} }).then(res => {
        if (res.body != 'false') {
          this.dnplan = res.body.dnplan
        } else {
          this.dnplan = []
        }
        
      }, error => {
          
      })
    }
  }
}
</script>
<style scoped>
.v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.v-input {
  font-size: 13px;
  min-width: 80px;
  max-width: 80px; 
}
.v-input input {
  max-height: 20px;
}
</style>